module.exports = __webpack_public_path__ + "static/img/empty.429b806a.svg";